import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import ProjectNameWidget from '../../widgets/projectProposal/project/ProjectNameWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../utils/loading'
import { getProjectName } from '../../redux/actions/projectName'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import pathname from '../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import ViewPreviousVersionButon from '../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ProjectName(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  
  // 🚩 เพิ่ม State ควบคุมสถานะการเปิด/ปิดโหมดเปรียบเทียบ
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.projectTypeInfo}`,
    pathNameForward: `${pathname.proposal.overview.overviewCoworker}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectName(proposalId)
      setSchema(_schema)
      setIsEditWidget({
        projectName: _schema.forms?.projectName?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.projectName?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // 🚩 ปรับ Logic เป็นสวิตช์เปิด-ปิด และลดการยิง API ซ้ำซ้อน
  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      // ปิดโหมดเปรียบเทียบ
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      // เปิดโหมดเปรียบเทียบ โดยใช้ข้อมูลที่เคยโหลดมาแล้ว
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      
      const _schema = await getProjectName(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 สกัดคอมโพเนนต์เวอร์ชันปัจจุบันออกมา เพื่อให้ใช้ซ้ำได้ง่าย และลดการซ้อนกันของโค้ด
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.projectName && (
        <ProjectNameWidget
          showCommandButton={!schema.forms.projectName.disabled}
          schema={schema.forms.projectName}
          isEdit={isEditWidget.projectName}
          onChangeIsEdit={(_isEdit) =>
            handleOnChangeIsEdit('projectName', _isEdit, setIsEditWidget)
          }
        />
      )}
    </div>
  )

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {/* 🚩 ส่งค่า isViewPrevious ไปให้ปุ่มรู้สถานะ */}
          <ViewPreviousVersionButon 
            handleGetSchemaPrevious={handleGetSchemaPrevious} 
            isViewPrevious={isViewPrevious}
            masterSubjectId={'1-1012'}
          />

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          <div className="wrapper">
            {/* ==============================================
                ส่วนที่ 1: ข้อมูลปัจจุบัน (มี Panel เฉพาะตอนเปรียบเทียบ)
                ============================================== */}
            <div style={!isViewPrevious ? { width: '100%' } : {}}>
              {isViewPrevious ? (
                <Panel 
                  //classPrefix="view-version-panel" 
                  collapsible 
                  defaultExpanded 
                  shaded 
                  bordered 
                  header={'version ปัจจุบัน'}
                  style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
                >
                  {renderCurrentVersion}
                </Panel>
              ) : (
                renderCurrentVersion
              )}
            </div>

            {/* ==============================================
                ส่วนที่ 2: ข้อมูลก่อนหน้า (ซ่อน/แสดง ตามสถานะ isViewPrevious)
                ============================================== */}
            {isViewPrevious && schemaPrevious && (
              <>
                <div className="line" />
                <div className="bottom">
                  {schemaPrevious?.forms?.projectName && (
                    <Panel 
                      collapsible 
                      defaultExpanded 
                      shaded 
                      bordered 
                      header={'version ก่อนหน้า'}
                      style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed'  }}
                    >
                      <ProjectNameWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.projectName}
                        isEdit={false}
                      />
                    </Panel>
                  )}
                </div>
              </>
            )}
          </div>
        </SidebarProposal>
      )}
    </>
  )
}